import { Log } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/message';
import { IContactsSetAction, IMessagesSetAction, IConversationListSetAction, IGroupsSetAction, ISetUnreadMessageCount, IHeaderMessageSetAction, ISetOriginMessageIdAction } from '../../models/action/messages';
import { MessagePageService } from '../../api/message-services_old';

const _logger = Log.create('Messages Reducer');

const messagesReducer = (state = GlobalState().message, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {...state};
    if (action.type === Actions.actions.SET_CONTACTS) {
        const messagesPageAction = action as IContactsSetAction;
        if (messagesPageAction.skip === 0) {
            newState.users = [];
        } else {
            newState.users = state.users;
        }
        newState.users = newState.users.concat(messagesPageAction.users);
        newState.usersTake = messagesPageAction.take;
        newState.usersSkip = messagesPageAction.skip;
        newState.usersTotalCount = messagesPageAction.totalCount;
    } else if (action.type === Actions.actions.SET_GROUPS) {
        const groupSetAction = action as IGroupsSetAction;
        if (groupSetAction.skip === 0) {
            newState.groups = [];
        } else {
            newState.groups = state.groups;
        }
        newState.groups = newState.groups.concat(groupSetAction.groups);
        newState.groupsTake = groupSetAction.take;
        newState.groupsSkip = groupSetAction.skip;
        newState.groupsTotalCount = groupSetAction.totalCount;
    } else if (action.type === Actions.actions.SET_MESSAGE_LIST) {
        const messagesPageAction = action as IMessagesSetAction;
        newState.messages = messagesPageAction.messages;
        newState.currentContextId = messagesPageAction.contextId;
        newState.currentContextType = messagesPageAction.contextType;
        newState.chatTitleImages = messagesPageAction.imageUrl;
        newState.chatSkip = messagesPageAction.skip;
        newState.chatTake = messagesPageAction.take;
        newState.chatTotal = messagesPageAction.total;
        newState.chatTitleText = messagesPageAction.chatTitleText;
        newState.originMessageId = messagesPageAction.originMessageId;
        newState.contextId = messagesPageAction.contextId;
    } else if (action.type === Actions.actions.SET_LOAD_MORE_MESSAGES) {
        const messagesPageAction = action as IMessagesSetAction;
        if (messagesPageAction.skip === 0) {
            newState.messages = [];
        } else {
            newState.messages = state.messages;
        }
        newState.messages = newState.messages.concat(messagesPageAction.messages);
        newState.currentContextId = messagesPageAction.contextId;
        newState.currentContextType = messagesPageAction.contextType;
        newState.chatTitleImages = messagesPageAction.imageUrl;
        newState.chatSkip = messagesPageAction.skip;
        newState.chatTake = messagesPageAction.take;
        newState.chatTotal = messagesPageAction.total;
        newState.chatTitleText = messagesPageAction.chatTitleText;
        newState.originMessageId = messagesPageAction.originMessageId;
        newState.contextId = messagesPageAction.contextId;
    } else if (action.type === Actions.actions.SET_CONVERSATION_LIST) {
        const messagesPageAction = action as IConversationListSetAction;
        if (messagesPageAction.isGroup) {
            newState.groupConversations = messagesPageAction.conversations;
            newState.groupConversations.totalCount = messagesPageAction.totalCount;
            newState.messageListTake = messagesPageAction.take;
        } else {
            newState.userConversations = messagesPageAction.conversations;
            newState.userConversations.totalCount = messagesPageAction.totalCount;
            newState.messageListTake = messagesPageAction.take;
        }
    }
    else if (action.type === Actions.actions.SET_HEADER_MESSAGE_LIST) {
        const messagesHeaderPageAction = action as IHeaderMessageSetAction;
        newState.conversations = messagesHeaderPageAction.conversations;
    }
    else if (action.type === Actions.actions.SET_DEFAULT_CHATPANEL_MESSAGE) {
        newState.originMessageId = null;
    } 
    else if (action.type === Actions.actions.SET_UNREAD_MESSAGE_COUNT) {
        const unreadMessage = action as ISetUnreadMessageCount;
        newState.mainMenuMessageUnread = unreadMessage.unreadMessageCount && unreadMessage.unreadMessageCount > 0 ? true : false;
        newState.unreadMessageCount = unreadMessage.unreadMessageCount;
    }
    else if (action.type === Actions.actions.SET_ORIGIN_MESSAGE_ID) {
        const messagesPageAction = action as ISetOriginMessageIdAction;
        newState.originMessageId = messagesPageAction.originMessageId;
        newState.chatTitleText = messagesPageAction.chatTitleText;
        newState.chatTitleImages = messagesPageAction.imageUrl;
    }
    else {
        return state;
    }
    return Object.assign({}, state, newState);
};

export default messagesReducer;
